// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen {
    .only-print {
        display: none !important;
    }
}

@media print {
    .new-navbar,
    .back-to-map,
    .footer ul,
    .export-tdb-methodo-pdf,
    .do-not-print,
    .bouton-methodo {
        display: none !important;
    }

    .title > h1,
    .description-tableau-bord {
        margin-bottom: 40px !important;
    }

    .widgets {
        top: 10px !important;
    }
    .structure-thematique {
        display: block !important;
    }

    .text-block-show,
    .description-tableau-bord {
        column-count: 3;
        column-width: 17em;
        column-gap: 3em;
    }
    .text-block-show {
        border: 1px solid var(--vert-primary) !important;
    }

    a.no-link-description::after {
        content: "";
    }

    a::after {
        content: " (" attr(href) ")";
        line-break: anywhere;
        font-size: 12px;
    }

    .dashboard-territory-choice {
        break-after: always !important;
    }

    .dashboard-group {
        page-break-before: always;
        break-before: all !important;
        break-inside: avoid !important;
        border: none !important;
    }
    .formulaire-thematique {
        break-inside: avoid !important;
    }

    .only-print {
        margin: auto;
    }
    .only-print a {
        font-size: 12px;
    }

    .footer {
        height: 110px !important;
        border-top: 0px !important;
        position: static !important;
        break-inside: avoid !important;
    }
    .footer .left-logos,
    .footer .right-logos,
    .footer-block {
        float: none !important;
        display: block !important;
        position: static !important;
    }

    div.territories-are-1 {
        zoom: 85%;
    }
    div.territories-are-2 {
        zoom: 65%;
    }
    div.territories-are-3 {
        zoom: 45%;
    }
}

.background-warning {
    /* Browsers change the white font color if backgrounds are disabled.
    This element will only be visible in that case. */
    font-size: 12pt;
    background-color: white;
    color: white;
}
`, "",{"version":3,"sources":["webpack://./src/style/dashboard_print.css"],"names":[],"mappings":"AAAA;IACI;QACI,wBAAwB;IAC5B;AACJ;;AAEA;IACI;;;;;;QAMI,wBAAwB;IAC5B;;IAEA;;QAEI,8BAA8B;IAClC;;IAEA;QACI,oBAAoB;IACxB;IACA;QACI,yBAAyB;IAC7B;;IAEA;;QAEI,eAAe;QACf,kBAAkB;QAClB,eAAe;IACnB;IACA;QACI,gDAAgD;IACpD;;IAEA;QACI,WAAW;IACf;;IAEA;QACI,4BAA4B;QAC5B,oBAAoB;QACpB,eAAe;IACnB;;IAEA;QACI,8BAA8B;IAClC;;IAEA;QACI,yBAAyB;QACzB,4BAA4B;QAC5B,8BAA8B;QAC9B,uBAAuB;IAC3B;IACA;QACI,8BAA8B;IAClC;;IAEA;QACI,YAAY;IAChB;IACA;QACI,eAAe;IACnB;;IAEA;QACI,wBAAwB;QACxB,0BAA0B;QAC1B,2BAA2B;QAC3B,8BAA8B;IAClC;IACA;;;QAGI,sBAAsB;QACtB,yBAAyB;QACzB,2BAA2B;IAC/B;;IAEA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;IACA;QACI,SAAS;IACb;AACJ;;AAEA;IACI;qDACiD;IACjD,eAAe;IACf,uBAAuB;IACvB,YAAY;AAChB","sourcesContent":["@media screen {\n    .only-print {\n        display: none !important;\n    }\n}\n\n@media print {\n    .new-navbar,\n    .back-to-map,\n    .footer ul,\n    .export-tdb-methodo-pdf,\n    .do-not-print,\n    .bouton-methodo {\n        display: none !important;\n    }\n\n    .title > h1,\n    .description-tableau-bord {\n        margin-bottom: 40px !important;\n    }\n\n    .widgets {\n        top: 10px !important;\n    }\n    .structure-thematique {\n        display: block !important;\n    }\n\n    .text-block-show,\n    .description-tableau-bord {\n        column-count: 3;\n        column-width: 17em;\n        column-gap: 3em;\n    }\n    .text-block-show {\n        border: 1px solid var(--vert-primary) !important;\n    }\n\n    a.no-link-description::after {\n        content: \"\";\n    }\n\n    a::after {\n        content: \" (\" attr(href) \")\";\n        line-break: anywhere;\n        font-size: 12px;\n    }\n\n    .dashboard-territory-choice {\n        break-after: always !important;\n    }\n\n    .dashboard-group {\n        page-break-before: always;\n        break-before: all !important;\n        break-inside: avoid !important;\n        border: none !important;\n    }\n    .formulaire-thematique {\n        break-inside: avoid !important;\n    }\n\n    .only-print {\n        margin: auto;\n    }\n    .only-print a {\n        font-size: 12px;\n    }\n\n    .footer {\n        height: 110px !important;\n        border-top: 0px !important;\n        position: static !important;\n        break-inside: avoid !important;\n    }\n    .footer .left-logos,\n    .footer .right-logos,\n    .footer-block {\n        float: none !important;\n        display: block !important;\n        position: static !important;\n    }\n\n    div.territories-are-1 {\n        zoom: 85%;\n    }\n    div.territories-are-2 {\n        zoom: 65%;\n    }\n    div.territories-are-3 {\n        zoom: 45%;\n    }\n}\n\n.background-warning {\n    /* Browsers change the white font color if backgrounds are disabled.\n    This element will only be visible in that case. */\n    font-size: 12pt;\n    background-color: white;\n    color: white;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
